import { Component, Output, EventEmitter } from '@angular/core'

@Component({
  selector: 'keywords-help-modal',
  template: `
    <modal (outsideClick)="close()">
      <h4>Topics</h4>
      <hr class="brand-hr">
      <p>
        These are the subjects that you want your blog posts to be about. Each post you get from Verblio will be on one of these topics and will include an SEO-friendly version of your topic in both the headline and the body of the post.
        <a href='/help/keyword_definition' target='_blank'>
          Learn more about topics.
        </a>
      </p>
      <p>
        <strong>Ongoing:</strong>
        These are the topics that you want several posts on, or would like to use on a recurring basis.
      </p>
      <p>
        <strong>One-time:</strong>
        These are topics that you only want a single blog post on. Once you purchase a post on a one-time topic, the topic disappears from your available topics list. One-time topics are useful for time-sensitive events or if you're using a set editorial calendar.
      </p>
      <p>
        <strong>Paused:</strong>
        Paused topics are not visible to the writers. If you don't want writers to submit posts on a particular topic for awhile, pause the topic. Your topic descriptions will be saved for later.
      </p>
      <p>
        <span class="fa-stack stack-shrink">
          <i class="far fa-file fa-stack-2x"></i>
            <strong class="fa-stack-1x fa-stack-text stack-shrink-text">
              3
            </strong>
        </span>:
        This number indicates the number of purchased posts for the given topic.
      </p>
      <button class='btn btn-default top-buffer' (click)='close()'>
        Ok got it.
      </button>
    </modal>
  `
})
export class KeywordsHelpModal {
  @Output() onClose = new EventEmitter();

  close() {
    this.onClose.emit('close')
  }

}
